const btnFixed = document.querySelectorAll('[data-btn-fixed]');
const posActive = 400;
if(btnFixed.length) {
	btnFixed.forEach((el) => {
		window.addEventListener('scroll', () => {
			let scroll = window.pageYOffset;
			if (scroll >= posActive) {
				el.classList.add('is-active');
			} else {
				el.classList.remove('is-active');
			}
		});
	});
}